import { Reveal, Chapter } from "./primitives";
import { useLanguage } from "../../i18n/LanguageContext";

export const Careers = () => {
  const { t } = useLanguage();
  const C = t.careers;
  return (
    <section className="relative bg-kn-ice py-24 lg:py-32" data-testid="careers-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <Chapter index="" label={C.eyebrow} />
          <h2 className="mt-6 max-w-3xl text-4xl font-semibold leading-[1.12] tracking-tight text-kn-navy sm:text-5xl">
            {C.h2a}{" "}
            <span className="font-serif italic font-normal text-brand-gradient block">{C.h2b}</span>
          </h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-kn-navy/60">{C.sub}</p>
        </Reveal>
        <div className="mt-14 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-kn-navy/10 bg-kn-navy/10 sm:grid-cols-3 lg:grid-cols-4" data-testid="careers-grid">
          {C.categories.map((c, i) => (
            <Reveal key={c} delay={(i % 4) * 0.06} className="h-full">
              <div className="group flex h-full items-center justify-between gap-3 bg-white px-6 py-7 transition-colors duration-500 hover:bg-kn-navy">
                <span className="text-sm font-medium text-kn-navy transition-colors duration-500 group-hover:text-white">{c}</span>
                <span className="font-mono text-[10px] text-kn-navy/30 transition-colors duration-500 group-hover:text-kn-cyan">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
